/**
 * Parse CSV to array of numbers.
 * NOTE: All NaN values are filter out.
 * @param input String of comma separated list of numbers.
 * @param delimiter Delimiter used to separate values.
 * @returns Array of numbers.
 */
export function csvToNumberArray(
  input: string,
  delimiter: string = ','
): number[] {
  return input
    .split(delimiter)
    .map((v) => parseInt(v, 10))
    .filter((v) => !Number.isNaN(v));
}
